import { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../../../../../components/Footer/Footer";
import InnerNav from "../../../../../components/InnerNav/InnerNav";
import { useFormData } from "../../ContextData/ContextData";

import "./TransitToday.scss";
import LagnaChart from "../PlanetPos/charts/lagna/lagna";
import TransitChart from "./TransitChart/TransitChart";

const TransitToday = () => {
  const { userData } = useFormData();
  const [transitData, setTransitData] = useState(null);
  const [loading, setLoading] = useState(true);

  // Columns for table
  const columns = [
    "Planet",
    "Rashi",
    "Longitude",
    "Nakshatra",
    "Retrograde",
    "AV Points",
  ];

  useEffect(() => {
    const fetchTransit = async () => {
      try {
        const res = await axios.get(
          "https://core-c343.onrender.com/api/ashtakvarga/transit",
          {
            params: {
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute,
              timezone: "Asia/Kolkata",
            },
          }
        );

        setTransitData(res.data.ashtakvargaTransit || []);
      } catch (error) {
        console.error("Error fetching transit data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransit();
  }, []);

  if (loading) return <p className="loading">Loading transit data...</p>;

  if (!transitData) return <p className="error">Failed to load transit data.</p>;

  return (
    <div className="transit-container">
      <InnerNav />
      <div className="transit-content">
        <h1>Transit Chart</h1>
        <div className="transit-chart">
          <div className="transit-chart-card">
            <LagnaChart/>
          </div>
          <div className="transit-chart-card">
            <TransitChart/>
          </div>
        </div>
        <h1>Transit Today</h1>

        <div className="transit-table">
          <table>
            <thead>
              <tr>
                {columns.map((col, idx) => (
                  <th key={idx}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {transitData.map((row, i) => (
                <tr key={i}>
                  <td>{row.planet}</td>
                  <td>{row.rashi}</td>
                  <td>{row.longitude}</td>
                  <td>{row.nakshatra}</td>
                  <td>{row.retrograde || "-"}</td>
                  <td>{row.avPoints !== "" ? row.avPoints : "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TransitToday;
